import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { NameWithDigitsFormControl } from './name-with-digits-form-control';

@Component({
  standalone: false,
  selector: 'app-name-with-digits-form-control',
  templateUrl: './name-with-digits-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NameWithDigitsFormControlComponent),
      multi: true
    }
  ]
})
export class NameWithDigitsFormControlComponent
  extends AbstractFormControlComponent<NameWithDigitsFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() placeholder: string;
  @Input() floatLabel: string;
  @Input() inline: boolean;
  @Output() onChanged: EventEmitter<any> = new EventEmitter();

  faCheck: any = faCheck;

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(value: any): void {
    this.onChanged.emit(value);
  }

  public get maxLength(): number {
    return this.control.maxLength;
  }

  public get capitalizeAll(): boolean {
    return this.control.capitalizeAll || false;
  }

  public get placeholderText(): string {
    return this.placeholder || '';
  }

  public get floatLabelText(): string {
    return this.floatLabel || 'always';
  }

  public get isInline(): boolean {
    return this.inline || false;
  }

  get hideErrorMessages(): boolean {
    return this.control?.hideErrorMessages;
  }

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  showErr(err: any) {
    return JSON.stringify(err);
  }
}
